import { PagedResultDto } from '@shared/components/paged-listing-component-base';
import { OrganizationDto } from './organization-dto';

export class OrganizationPagedResultDto extends PagedResultDto {
  public items: OrganizationDto[] = [];
}
